<template>
  <div class="content">
    <h1>{{ chitchat.title }}</h1>
    <div class="cover-section">
      <div class="tips">
        <div>
          {{ chitchat.content }}
        </div>
        <div class="row">
          <div class="col-sm-1" v-for="(image, index) in chitchat.images" :key="index">
            <img :src="image" />
          </div>
        </div>
      </div>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">기본 정보</h4>
      <card class="text-left">
        <div class="row">
          <label class="col-md-2 col-form-label key">ID</label>
          <label class="col-md-3 col-form-label value">{{ chitchat.id }}</label>
          <base-button class="update-button col-md-2" @click.prevent="goSharePage" type="confirm">공유페이지</base-button>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">작성자</label>
          <div class="col-md-10" v-if="isAdminAuthor">
            <el-select class="select-primary" size="large" placeholder="작성자" v-model="selectedAuthorId">
              <el-option v-for="option in authorOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
            <base-button class="update-button col-6" @click.prevent="onClickUpdateAuthor" type="confirm">업데이트</base-button>
          </div>
          <label class="col-md-10 col-form-label value" v-if="!isAdminAuthor"
            ><a class="pointer" @click="goUserDetail(chitchat.userId)">{{ `${chitchat.nickname} (${chitchat.userId})` }}</a></label
          >
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">조회수</label>
          <span class="col-md-10 col-form-label value">{{ chitchat.viewCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">좋아요 수</label>
          <span class="col-md-10 col-form-label value">{{ chitchat.likeCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">댓글수</label>
          <span class="col-md-10 col-form-label value">{{ chitchat.commentCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">저장 수</label>
          <span class="col-md-10 col-form-label value">{{ chitchat.pinCount }}</span>
        </div>

        <div class="row">
          <label class="col-md-2 col-form-label key">작성일시</label>
          <div class="col-md-10">
            <base-input class="date-picker" placeholder="작성일시">
              <el-date-picker type="datetime" placeholder="작성일시" v-model="chitchat.regTime" disabled></el-date-picker>
            </base-input>
          </div>
        </div>
      </card>
    </div>
    <div class="row actions">
      <div v-if="chitchat.state === 1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="onClickDelete" type="success">삭제</base-button>
      </div>
      <div v-if="chitchat.state === 1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="onClickHide" type="success">숨김</base-button>
      </div>
      <div v-if="chitchat.state !== 1" class="col-md-2">
        <base-button class="footer-buttons col-md-12" @click="onClickShow" type="success">표시</base-button>
      </div>

      <div class="col-md-2"><base-button class="footer-buttons col-md-12" @click="onClickComments" type="success">댓글 조회</base-button></div>
    </div>

    <div class="report-section">
      <h4 class="section-title pull-left">신고 내역</h4>
      <card>
        <div class="row">
          <ReportsForContentTableView class="col-12" :reports="reports" />
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { BaseButton, BaseInput, Card } from "@/components/index";
import ReportsForContentTableView from "@/pages/Reports/ReportsForContentTableView";
import { BlipNamespace } from "@/common/BlipNamespace";
import { Alert } from "@/util/Alert";
import { TopicState } from "@/common/TopicState";
import * as _ from "lodash";
import Endpoints from "@/common/Endpoints";

export default {
  name: "ChitchatDetail",
  components: {
    BaseButton,
    Card,
    BaseInput,
    ReportsForContentTableView,
  },
  data() {
    return {
      chitchat: null,
      artistUnit: null,
      isAdminAuthor: false,
      reports: [],
      dummyAuthors: [],
      authorOptions: [],
      selectedAuthorId: null,
      searchText: null,
    };
  },
  mounted: async function () {
    await this.getChitchat();
  },
  methods: {
    async getChitchat() {
      try {
        const chitchatId = this.$route.params.chitchatId;
        const result = await this.$axios.get(`/chitchats/${chitchatId}`);
        this.chitchat = result.data.data;

        const roleResult = await this.$axios.get(`/users/${this.chitchat.userId}/roles`);
        this.isAdminAuthor = _.some(roleResult.data.data, (role) => {
          return role.includes("blipContentAdmin") || role.includes(`dummyUnitFollower/${this.chitchat.unitId}`);
        });

        if (this.isAdminAuthor) {
          await this.getDummyAuthors(this.chitchat.unitId);
        }

        if (this.chitchat.imageIds) {
          this.chitchat.images = [];
          const imageIds = this.chitchat.imageIds.split(",");
          for (const imageId of imageIds) {
            this.chitchat.images.push(window.Endpoints.imageServerUrl + imageId);
          }
        }
        await this.getReports();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getDummyAuthors(unitId) {
      try {
        const dummyUsers = await this.$axios.get(`/artistUnit/${unitId}/dummyUsers`);
        const contentAdmins = await this.$axios.get(`/artistUnit/${unitId}/contentAdmins`);

        this.dummyAuthors = dummyUsers.data.data.users.concat(contentAdmins.data.data.users);

        this.selectedAuthorId = this.chitchat.userId;

        this.authorOptions = [
          { label: `${this.chitchat.nickname}(${this.chitchat.userId})`, value: this.chitchat.userId },
          ...this.dummyAuthors
            .filter((author) => author.id !== this.chitchat.userId)
            .map((author) => ({
              label: `${author.nickname}(${author.id})`,
              value: author.id,
            })),
        ];
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    async getReports() {
      try {
        const result = await this.$axios.get(`/chitchats/${this.chitchat.id}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    goSharePage() {
      window.open(`${Endpoints.sharePageUrl}/cc/${this.chitchat.idHash}`);
    },
    async onClickHide() {
      if (await Alert.dangerousConfirmCancel("숨김 확인", `${this.chitchat.title} 잡담을 숨김 처리 하시겠습니까?`)) {
        try {
          await this.$axios.put(`/chitchats/${this.chitchat.id}/state`, { state: TopicState.INVISIBLE });
          window.Toast.success("잡담이 숨김 처리 되었습니다.");
          this.$router.back();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickDelete() {
      if (await Alert.dangerousConfirmCancel("삭제 확인", `${this.chitchat.title} 잡담을 삭제하시겠습니까?`, "삭제", "취소")) {
        try {
          await this.$axios.delete(`/chitchats/${this.chitchat.id}`);
          window.Toast.success("잡담이 삭제되었습니다.");
          this.$router.back();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickShow() {
      if (await Alert.dangerousConfirmCancel("표시 확인", `${this.chitchat.title} 잡담을 표시하시겠습니까?`)) {
        try {
          await this.$axios.put(`/chitchats/${this.chitchat.id}/state`, { state: TopicState.VISIBLE });
          window.Toast.success("잡담이 표시 처리 되었습니다.");
          // reload.
          this.$router.go(0);
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },

    async onClickUpdateAuthor() {
      try {
        const result = await this.$axios.put(`/chitchats/${this.chitchat.id}/author`, {
          userId: this.selectedAuthorId,
        });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickComments() {
      this.$router.push(`/comment/all?namespace=${BlipNamespace.CHITCHAT}&unitId=${this.chitchat.unitId}&contentId=${this.chitchat.id}`);
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  text-align: unset;
}

.cover-section {
  .a-or-b {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .cell {
      width: 50%;
      img {
        max-width: 50%;
        min-height: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
  }

  .tips {
    img {
      margin-bottom: 30px;
    }
  }
}

.section-title {
  text-decoration: underline;
}

.key {
  font-weight: bold;
}

.actions {
  margin-bottom: 40px;
}

.update-button {
  margin-left: 10px;
  padding-left: 5px;
  padding-right: 5px;
  width: 80px;
}

.date-picker {
  display: inline-block;
}
.pointer {
  cursor: pointer;
}
</style>
